






















































import {
  IWorkflowFormSection,
  IWorkflowFormTemplate,
  IWorkflowFormTemplateRevision
} from '@/models';

import WorkflowFormBuilderGeneralTab from './tabs/WorkflowFormBuilderGeneralTab.vue';
import WorkflowFormBuilderOptionTab from './tabs/WorkflowFormBuilderOptionTab.vue';
import WorkflowFormBuilderConstraintsTab from './tabs/WorkflowFormBuilderConstraintsTab.vue';

import Proxyable from '@/mixins/proxyable';
import {
  defineComponent,
  InjectionKey,
  PropType,
  provide
} from '@vue/composition-api';

export enum PropertyTabs {
  General,
  Option,
  Constraint,
  Computation
}

export const WorkflowFormBuilderForm: InjectionKey<boolean> = Symbol.for(
  'workflow-form-builder:form'
);

export default defineComponent({
  mixins: [Proxyable],

  components: {
    WorkflowFormBuilderCalculationTab: () =>
      import('./tabs/WorkflowFormBuilderCalculationTab.vue'),
    WorkflowFormBuilderConstraintsTab,
    WorkflowFormBuilderGeneralTab,
    WorkflowFormBuilderOptionTab
  },

  props: {
    revision: Object as PropType<IWorkflowFormTemplateRevision>,
    template: Object as PropType<IWorkflowFormTemplate>,
    section: Object as PropType<IWorkflowFormSection>,
    selectedFieldIndex: {
      type: Number,
      required: false
    },
    drawer: Boolean
  },

  provide(): object {
    return { isFormDisabled: this.revision?.isPublished() };
  },

  data() {
    return {
      PropertyTabs,
      tab: PropertyTabs.General
    };
  },

  computed: {
    localFieldSection: {
      get(): IWorkflowFormSection | undefined {
        return this.section;
      },
      set(value: IWorkflowFormSection) {
        this.$emit('update:section', value);
      }
    }
  },

  methods: {
    save() {
      this.$emit('save');
    },

    close() {
      // Keep as any due to using defineComponent. Nested components use composition api and vue 2 options provide API is not backwards compatible
      (this as any).internalValue = false;
    },

    goToTabWindow(tab: PropertyTabs) {
      this.tab = tab;
    }
  },

  setup(props) {
    provide(WorkflowFormBuilderForm, props.revision?.isPublished());
  }
});
